<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col-12 col-md-12 col-lg-8">
          <h1 class="text-white pt-3 px-3">รายงานยอดค้างชำระของสาขา</h1>
          <p
            class="text-white pb-0 px-3"
          >แสดงข้อมูลสาขา ชื่อเจ้าของ ยอดที่ค้างชำระทางสาขา และยอดที่ต้องชำระทาง {{$THEME.webTitle}}</p>
        </div>
        <div class="col-12 col-md-12 col-lg-4 align-self-center text-right">
          <h1 class="display-3 text-white">
            <small>จำนวนร้านค้าทั้งหมด :</small>
            {{pagination.total_shop| numFormat('0,0')}}
            <small>ร้าน</small>
          </h1>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col-12">
                  <b-form-group>
                    <b-form-radio-group
                      id="radio-group-date"
                      v-model="selectTypeDate"
                      name="radio-sub-date"
                    >
                      <b-form-radio value="date_time_weight">วันที่ได้รับน้ำหนักจากขนส่ง</b-form-radio>
                      <b-form-radio value="date_time_shipping">วันที่จัดส่งพัสดุ</b-form-radio>
                      <b-form-radio value="created_at">วันที่สร้าง</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-12 col-lg-12 col-xl-6 mb-3 mb-md-0">
                  <b-form-group label="ค้นหาวันที่ส่งพัสดุ (วันเริ่มต้น - วันสุดท้าย)" class="mb-0">
                    <div class="row">
                      <div class="col-lg-10">
                        <date-range-picker
                          class="w-100"
                          :opens="'center'"
                          @start-selection="logEvent('startSelection', $event)"
                          @finish-selection="logEvent('finishSelection', $event)"
                          :min-date="minDate"
                          :max-date="maxDate"
                          :singleDatePicker="false"
                          :appendToBody="true"
                          :ranges="false"
                          :closeOnEsc="false"
                          :autoApply="true"
                          :locale-data="{ format: 'dd/mm/yyyy' }"
                          v-model="filters" >
                        </date-range-picker>
                      </div>
                      <!-- <div class="col-6 col-md-4 col-lg-5 content--">
                        <input type="date" v-model="filters.date_start" class="form-control" />
                      </div>
                      <div class="col-6 col-md-4 col-lg-5 mb-3">
                        <input type="date" v-model="filters.date_end" class="form-control" />
                      </div> -->
                      <div class="col-12 col-md-3 col-lg-2">
                        <button class="btn btn-info btn-sm-res" v-on:click="getReportBrance()">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </b-form-group>
                  <hr class="d-block d-md-none d-lg-none mb-0" />
                </div>
                <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3 mb-md-0">

                   <b-form-group
                    id="input-group-1"
                    label="ค้นหาข้อมูล"
                    label-for="input-1"
                    class="mb-0"
                  >
                    <b-form-input v-model="filter" type="text" placeholder="ค้นหาข้อมูล"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6 col-lg-2 col-xl-2">
                  <b-form-group label="Export File" class="mb-0 pb-2">
                    <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                      <ExportExcel 
                        :columns="columnExportExcelFrontPage" 
                        :getData="exportTotalOrderShippop"
                        name="สรุปยอดส่งพัสดุ "
                        :date="filters.date_excel"
                        :disabled="false"
                      >
                      </ExportExcel>
                      <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                    </div>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div id="tablePrint">
              <b-table
                show-empty
                responsive
                empty-text="ไม่มีรายละเอียดข้อมูลยอดขาย"
                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                class="scroll-bar-pop text-center table-sticky"
                :sort-desc="true"
                :items="reportBrance"
                :fields="fields"
                :filter="filter"
                :per-page="pagination.perPage"
                :current-page="pagination.current_page"
                :busy="busy"
                foot-clone
              >
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                <template slot="export" slot-scope="data" >
                  <ExportExcel 
                    :columns="columnExportExcel" 
                    :getData="() => exportOrderShippop(data.item.id)"
                    name="สรุปยอดส่งของพัสดุ "
                    :date="filters.date_excel"
                    :disabled="data.item.nums < 1"
                  >
                  </ExportExcel>
                </template>
                <!-- footer table -->
                <template slot="FOOT_index"> รวม</template>
                <template slot="FOOT_shop_code"> &nbsp;</template>
                <template slot="FOOT_dealer_id"> &nbsp;</template>
                <template slot="FOOT_shop_name"> &nbsp;</template>
                <template slot="FOOT_owner_name"> &nbsp;</template>
                <template slot="FOOT_province"> &nbsp;</template>
                <template slot="FOOT_nums">{{footerTotal.nums | numFormat('0,0')}}</template>
                <template slot="FOOT_cost">{{footerTotal.cost | numFormat('0,0.00')}}</template>
                <template slot="FOOT_rcost">{{footerTotal.rcost | numFormat('0,0.00')}}</template>
                <template slot="FOOT_rate">{{footerTotal.rate | numFormat('0,0.00')}}</template>
                <template slot="FOOT_r_rate">{{footerTotal.r_rate | numFormat('0,0.00')}}</template>
                <template slot="FOOT_price">{{footerTotal.price | numFormat('0,0.00')}}</template>
                <template slot="FOOT_cod_amount">{{footerTotal.cod_amount | numFormat('0,0.00')}}</template>
                <template slot="FOOT_remote_area">{{footerTotal.remote_area | numFormat('0,0.00')}}</template>
                <template slot="FOOT_r_remote_area">{{footerTotal.r_remote_area | numFormat('0,0.00')}}</template>
                <template slot="FOOT_travel_surcharge">{{footerTotal.travel_surcharge | numFormat('0,0.00')}}</template>
                <template slot="FOOT_r_travel_surcharge">{{footerTotal.r_travel_surcharge | numFormat('0,0.00')}}</template>
                <template slot="FOOT_island_surcharge">{{footerTotal.island_surcharge | numFormat('0,0.00')}}</template>
                <template slot="FOOT_r_island_surcharge">{{footerTotal.r_island_surcharge | numFormat('0,0.00')}}</template>
                <template slot="FOOT_fuel_surcharge">{{footerTotal.fuel_surcharge | numFormat('0,0.00')}}</template>
                <template slot="FOOT_r_fuel_surcharge">{{footerTotal.r_fuel_surcharge | numFormat('0,0.00')}}</template>
                <template slot="FOOT_insurance_cost">
                  {{footerTotal.insurance_cost | numFormat('0,0.00')}}
                </template>
                <template slot="FOOT_insurance_rate">
                  {{footerTotal.insurance_rate | numFormat('0,0.00')}}
                </template>
                <template slot="FOOT_export">&nbsp;</template>
             

              </b-table>
              <div class="mt-3">
                <!-- <b-pagination 
                    :total-rows="pagination.total_shop"
                    :current-page="pagination.current_page"
                    :per-page="pagination.per_page"
                    :value="pagination.current_page" 
                    @input="changePage"
                    align="right">
                </b-pagination> -->
                <b-pagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total_shop"
                  :per-page="pagination.perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalNotification :notiShop="noti" />
  </div>
</template>
<script>
import validatePop from "../../plugins/validatePop.js"
import ModalNotification from '@/components/custom/ModalNotification'
import moment from "moment"
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import { checkStatusShop } from "@/axios/noti.js";
import { dateLimitRanges } from "@/plugins/datePicker.js"

const API_URL = process.env.VUE_APP_API
export default {
  components:{
    ModalNotification,
    ExportExcel
  },
  data() {
    return {
      selectTypeDate: "created_at",
      pagination:{
        total_shop: 0,
        current_page: 1,
        perPage:100
      },
      minDate: null,
      maxDate: moment().format("YYYY-MM-DD"),
      reportBrance: [],
      expend_to_shippop: 0,
      date: new Date(),
      busy: true,
      columnExportExcelFrontPage:[
        {
          label: "รหัสร้านค้า",
          field: "shop_code",
          dataFormat: value => {
            return (value) ? `${value}` : 'รวม';
          } 
        },
        {
          label: "รหัสตัวแทน",
          field: "dealer_id",
        },
        {
          label: "ชื่อสาขา",
          field: "shop_name",
        },
        {
          label: "ชื่อเจ้าของ",
          field: "owner_name",
        },
        {
          label: "จังหวัด",
          field: "province",
        },
        {
          label: "ยอดการส่งพัสดุ(ชิ้น)",
          field: "nums",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0')}`;
          } 
        },
        {
          label: "ยอดต้นทุน",
          field: "cost",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอดต้นทุนจริง",
          field: "rcost",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอดต้นทุนร้านค้า",
          field: "rate",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอดต้นทุนร้านค้าจริง",
          field: "r_rate",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอดรวมราคาขาย",
          field: "price",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอดรวม COD",
          field: "cod_amount",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอดรวมต้นทุนประกัน",
          field: "insurance_cost",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอดรวมต้นทุนประกัน(ร้านค้า)",
          field: "insurance_rate",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ค่าบริการพื้นที่พิเศษ",
          field: "remote_area",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ค่าบริการพื้นที่พิเศษจริง",
          field: "r_remote_area",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ค่าบริการพื้นที่ท่องเที่ยว",
          field: "travel_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ค่าบริการพื้นที่ท่องเที่ยวจริง",
          field: "r_travel_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ค่าพื้นที่หมู่เกาะ",
          field: "island_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ค่าพื้นที่หมู่เกาะจริง",
          field: "r_island_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "Additional Fuel Charge",
          field: "fuel_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "Additional Fuel Charge จริง",
          field: "r_fuel_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอดรวมต้นทุนประกัน",
          field: "insurance_cost",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอดรวมต้นทุนประกัน (ร้านค้า)",
          field: "insurance_rate",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        }
      ],
      columnExportExcel:[
        {
          label: "สถานะ",
          field: "status",
          dataFormat: value => {
            if( !value ){
              return 'รวม';
            }
            let res = 'รอเข้าระบบ'
            let status = value.toLowerCase()
            if( status == 'transferred'){
              res = 'โอนเงินสำเร็จแล้ว'
            }else if( status == 'pending_transfer'){
              res = 'รอดำเนินการโอนเงิน'
            }else if( status == 'complete'){
              res = 'นำส่งสำเร็จ'
            }else if( status == 'shipping'){
              res = 'กำลังนำส่ง'
            }else if( status == 'cancel' ){
              res = 'ยกเลิกสำเร็จแล้ว'
            }else if( status == 'pending_cancel' ){
              res = 'รอดำเนินการยกเลิก'
            }else if (status == 'booking') {
              res = 'รอขนส่งเข้ารับ'
            }
            return res
          }
        },
        {
          label: "ชื่อขนส่ง",
          field: "courier",
        },
        {
          label: "หมายเลขติดตามพัสดุ",
          field: "tracking_code",
        },
        {
          label: ( this.$THEME.unitKG ) ? 'น้ำหนัก (กิโลกรัม)':'น้ำหนัก (กรัม)',
          field: "weight",
          dataFormat: value => {
            return (value) ? ( (  this.$THEME.unitKG ) ? `${ (value / 1000) }` : `${value}` ) : '';
          }
        },
        {
          label: ( this.$THEME.unitKG ) ? 'น้ำหนักจริง (กิโลกรัม)':'น้ำหนักจริง (กรัม)',
          field: "rweight",
          dataFormat: value => {
            return (value) ? ( (  this.$THEME.unitKG ) ? `${ (value / 1000) }` : `${value}` ) : '';
          }
        },
        {
          label: "ขนาดพัสดุ กxยxส(ซม.)",
          field: "dimension",
          dataFormat: value => {
            return (value) ? ` ${value.width}x${value.length}x${value.height}` : '';
          }
        },
        {
          label: "ขนาดพัสดุจริง (ซม.)",
          field: "rdimension",
          dataFormat: value => {
            return (value) ? ( (+value.width) + (+value.length) + (+value.height) > 3 ) ? ` ${value.width}x${value.length}x${value.height}` : '-' : '' ;
          }
        },
        { 
          label: "ต้นทุน",
          field: "cost",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "ต้นทุนจริง",
          field: "rcost",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: this.$USER_LOGIN.get().isSuperadmin ?'ต้นทุนร้านค้า':'ต้นทุน',
          field: "rate",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: this.$USER_LOGIN.get().isSuperadmin ?'ต้นทุนร้านค้าจริง':'ต้นทุนจริง',
          field: "r_rate",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "ค่าบริการพื้นที่พิเศษ",
          field: "remote_area",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "ค่าบริการพื้นที่พิเศษจริง",
          field: "r_remote_area",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "ค่าบริการพื้นที่ท่องเที่ยว",
          field: "travel_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "ค่าบริการพื้นที่ท่องเที่ยวจริง",
          field: "r_travel_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "ค่าพื้นที่หมู่เกาะ",
          field: "island_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "ค่าพื้นที่หมู่เกาะจริง",
          field: "r_island_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "Additional Fuel Charge",
          field: "fuel_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        { 
          label: "Additional Fuel Charge จริง",
          field: "r_fuel_surcharge",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอด COD",
          field: "cod_amount",
          dataFormat: value => {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
          } 
        },
        {
          label: "ยอดรวมต้นทุนประกัน",
          field: "insurance_cost",
          dataFormat: value => {
            let cost = value ? value : 0
            return `${this.$options.filters.numFormat(cost, '0,0.00')}`
          } 
        },
        {
          label: "ยอดรวมต้นทุนประกัน(ร้านค้า)",
          field: "insurance_rate",
          dataFormat: value => {
            let rate = value ? value : 0
            return `${this.$options.filters.numFormat(rate, '0,0.00')}`
          } 
        },
        {
          label: "วันที่สร้างรายการ",
          field: "created_at",
        },
        {
          label: "วันที่ขนส่งเข้ารับพัสดุ",
          field: "date_time_shipping",
        },
        {
          label: "วันที่ได้รับน้ำหนักจากขนส่ง",
          field: "date_time_weight",
        },
        {
          label: "หมายเหตุ",
          field: "remark",
          dataFormat: value => {
            return (value) ? this.setFormatRemark( value ) : '';
          }
        }
      ],
      fields: [
        { key: "index", label: "ลำดับ", sortable: true },
        { key: "shop_code", label: "รหัสสาขา", sortable: true },
        { key: "dealer_id", label: "รหัสตัวแทน", sortable: true },  
        { key: "shop_name", label: "ชื่อสาขา", sortable: true },
        { key: "owner_name", label: "ชื่อเจ้าของ", sortable: true },
        { key: "province", label: "จังหวัด", sortable: true },
        { key: "nums", label: "ยอดการส่งพัสดุ(ชิ้น)", sortable: true },
        { key: "cost", label: "ยอดต้นทุน", sortable: true },
        { key: "rcost", label: "ยอดต้นทุนจริง", sortable: true },
        { key: "rate", label: "ยอดต้นทุนร้านค้า", sortable: true },
        { key: "r_rate", label: "ยอดต้นทุนร้านค้าจริง", sortable: true },
        { key: "price", label: "ยอดรวมราคาขาย", sortable: true },
        { key: "cod_amount", label: "ยอดรวม COD", sortable: true },
        { key: "remote_area", label: "ค่าบริการพื้นที่พิเศษ", sortable: true },
        { key: "r_remote_area", label: "ค่าบริการพื้นที่พิเศษจริง", sortable: true },
        { key: "travel_surcharge", label: "ค่าบริการพื้นที่ท่องเที่ยว", sortable: true },
        { key: "r_travel_surcharge", label: "ค่าบริการพื้นที่ท่องเที่ยวจริง", sortable: true },
        { key: "island_surcharge", label: "ค่าพื้นที่หมู่เกาะ", sortable: true },
        { key: "r_island_surcharge", label: "ค่าพื้นที่หมู่เกาะจริง", sortable: true },
        { key: "fuel_surcharge", label: "Additional Fuel Charge", sortable: true },
        { key: "r_fuel_surcharge", label: "Additional Fuel Charge จริง", sortable: true },
        { key: "insurance_cost", label: "ยอดรวมต้นทุนประกัน", sortable: true },
        { key: "insurance_rate", label: "ยอดรวมต้นทุนประกัน(ร้านค้า)", sortable: true },
        { key: "export", label: "export" }
      ],
      filter: null,
      filters: {
        startDate: moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD"),
        endDate: moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD"),
        date_excel: ""
      },
      noti:{
        show:false,
        type:"",
        created_by:"",
        router:false
      },
    };
  },
  filters: {
    toFixed: function(price, limit) {
      return price.toFixed(limit);
    }
  },
  mounted() {
    if(this.$USER_LOGIN.get().isSuperadmin){
        checkStatusShop().then(res => {
            if( res.status_shop == 'LOCK' ){
                this.noti.created_by = res.created_by
                this.noti.type = res.status_shop
                this.noti.show = true
            }
        })
    }
    // this.getDateNow(this.date)
    if( !this.$USER_LOGIN.get().isMaster ){
      let indexOfField = this.fields.findIndex( item => {
        return item.key === 'dealer_id'
      });

      let indexOfFieldExcel = this.columnExportExcelFrontPage.findIndex( item => {
        return item.field === 'dealer_id'
      });

      this.fields.splice( indexOfField , 1)
      this.columnExportExcelFrontPage.splice( indexOfFieldExcel , 1)
    }

    this.filters.date_excel = moment(new Date(), "YYYY-MM-DD").format("DD-MM-YYYY")
    this.getReportBrance()
  },
  methods: {
    logEvent( event , date ){
        const { minDate , maxDate } =  dateLimitRanges(event, date);
        this.minDate = minDate
        this.maxDate = maxDate
    },
    async exportOrderShippop( shopId ){
      return await this.$http
        .post(
          API_URL + "/admin/export/shippop/order", {
            start: this.filters.startDate,
            end: this.filters.endDate,
            dateType: this.selectTypeDate,  
            shop: shopId,
            payment_type: 'credit_term'
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }).then( res => {
            return this.formatExcelShip(res.data.data)
          })
    },
    async exportTotalOrderShippop(){
      return await this.$http
        .post(
          API_URL + "/admin/export/shippop/total/order", {
            start: this.filters.startDate,
            end: this.filters.endDate,
            page: false,
            selectTypeDate: this.selectTypeDate
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }).then( res => {
            return this.formatExcel(res.data.data.brance)
          })
    },
    changePage(i){
      if (this.pagination.current_page == i) return
      this.pagination.current_page = i
      this.getReportBrance()
    },
    getReportBrance() {
      this.busy = true
      this.$http
        .post(
          API_URL + "/admin/reports",
          {
            selectTypeDate: this.selectTypeDate,
            start: this.filters.startDate,
            end: this.filters.endDate,
            page: this.pagination.current_page,
            payment_type: 'credit_term'
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          let data = res.data.data
          let checkError = validatePop(res)
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.busy = false;
            this.showErrorModal(checkError.msg);
            return
          }

          this.reportBrance = Object.values( data.brance )
          this.pagination.total_shop = data.total_item

          this.busy = false
        });
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    getDateNow(myDate) {
      var month = ("0" + (myDate.getMonth() + 1)).slice(-2);
      var date = ("0" + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      var formattedDate = year + "-" + month + "-" + date;
      this.filters.startDate = formattedDate;
      this.filters.endDate = formattedDate;

    },
    setFormatRemark( data ){
      const user = this.$USER_LOGIN.get()
      if( !data.status ) return `-`

        let res = `พัสดุมีการอัพเดท มีรายละเอียดดังนี้\r\nน้ำหนัก (กรัม): ${data.data.order_log_update.weight} \r\nขนาดพัสดุ   (กxยxส ซม.) :${data.data.order_log_update.width}x${data.data.order_log_update.length}x${data.data.order_log_update.height} \r\nต้นทุน : ${data.data.order_log_update.cost} \r\nต้นทุนร้านค้า : ${data.data.order_log_update.rate} \r\nราคาขาย : ${data.data.order_log_update.price} \r\nวันที่สร้างรายการ : ${data.data.order_log_update.created_at}`


      if( user.isAdmin ) return res = `พัสดุมีการอัพเดท มีรายละเอียดดังนี้\r\nน้ำหนัก : ${data.data.order_log_update.weight}  \r\nขนาดพัสดุ (กxยxส ซม.) :${data.data.order_log_update.width}x${data.data.order_log_update.length}x${data.data.order_log_update.height} \r\nต้นทุน : ${data.data.order_log_update.rate} \r\nราคาขาย : ${data.data.order_log_update.price} \r\nวันที่สร้างรายการ : ${data.data.order_log_update.created_at}`
      
      if( !user.isAdmin && !user.isSuperadmin ) return res = `พัสดุมีการอัพเดท มีรายละเอียดดังนี้\r\nน้ำหนัก : ${data.data.order_log_update.weight} \r\nขนาดพัสดุ (กxยxส ซม.) :${data.data.order_log_update.width}x${data.data.order_log_update.length}x${data.data.order_log_update.height} \r\nราคาขาย : ${data.data.order_log_update.price} \r\nวันที่สร้างรายการ : ${data.data.order_log_update.created_at}`

      return res
                  
    },
    formatExcel(item){
      let data = [ ...item ];
      if(item.length > 0){
        let format = {
          shop_code:'',
          ...( ( this.$USER_LOGIN.get().isMaster ) ? { dealer_id: ''} : {} ),
          shop_name:'',
          owner_name:'',
          province:'',
          nums: this.footerTotal.nums,
          cost: this.footerTotal.cost,
          rcost: this.footerTotal.rcost,
          rate: this.footerTotal.rate,
          r_rate: this.footerTotal.r_rate,
          price: this.footerTotal.price,
          cod_amount: this.footerTotal.cod_amount,
          remote_area: this.footerTotal.remote_area,
          travel_surcharge: this.footerTotal.travel_surcharge,
          r_travel_surcharge: this.footerTotal.r_travel_surcharge,
          island_surcharge: this.footerTotal.island_surcharge,
          r_island_surcharge: this.footerTotal.r_island_surcharge,
          fuel_surcharge: this.footerTotal.fuel_surcharge,
          r_fuel_surcharge: this.footerTotal.r_fuel_surcharge,
          insurance_cost: this.footerTotal.insurance_cost,
          insurance_rate: this.footerTotal.insurance_rate,
        }
        data.push(format);
      }
      return data;
    },
    formatExcelShip(item){
      let data = [ ...item ];
      let total = { cost: 0, rcost: 0, rate: 0, r_rate: 0 , cod_amount: 0, 
        remote_area: 0, travel_surcharge: 0, insurance_cost: 0, insurance_rate: 0 };
      if(item.length > 0){
        data.forEach(item => {
          if( item.status != 'PENDING_CANCEL' && item.status != 'CANCEL' ){
            total.cost += +item.cost
            total.rcost += +item.rcost
            total.rate += +item.rate
            total.r_rate += +item.r_rate
            total.cod_amount += +item.cod_amount
            total.remote_area += +item.remote_area
            total.r_remote_area += +item.r_remote_area
            total.travel_surcharge += +item.travel_surcharge
            total.r_travel_surcharge += +item.r_travel_surcharge
            total.island_surcharge += +item.island_surcharge
            total.r_island_surcharge += +item.r_island_surcharge
            total.fuel_surcharge += +item.fuel_surcharge
            total.r_fuel_surcharge += +item.r_fuel_surcharge
            total.insurance_cost += +item.insurance_cost
            total.insurance_rate += +item.insurance_rate
          }
        });
        let format = {
          status:'',
          courier:'',
          tracking_code:'',
          weight:'',
          rweight:'',
          dimension:'',
          rdimension:'',
          cost: total.cost,
          rcost:  total.rcost,
          rate: total.rate,
          insurance_cost: total.insurance_cost,
          insurance_rate: total.insurance_rate,
          r_rate: total.r_rate,
          remote_area: total.remote_area,
          r_remote_area: total.r_remote_area,
          travel_surcharge: total.travel_surcharge,
          r_travel_surcharge: total.r_travel_surcharge,
          island_surcharge: total.island_surcharge,
          r_island_surcharge: total.r_island_surcharge,
          fuel_surcharge: total.fuel_surcharge,
          r_fuel_surcharge: total.r_fuel_surcharge,
          cod_amount: total.cod_amount,
          created_at:'',
          date_time_shipping:'',
          date_time_weight: '',
          remark:''
        }
        data.push(format);
      }
      return data;
    }
  },
  computed:{
    footerTotal() {
      let total = { nums: 0, cost: 0, rcost: 0, rate: 0, r_rate: 0 ,price: 0, cod_amount: 0, 
        remote_area: 0, r_remote_area: 0, travel_surcharge: 0, r_travel_surcharge: 0, 
        island_surcharge: 0, r_island_surcharge: 0, 
        fuel_surcharge: 0, r_fuel_surcharge: 0, insurance_cost: 0, insurance_rate: 0};
      this.reportBrance.forEach(item => {
        total.nums += +item.nums
        total.cost += +item.cost
        total.rcost += +item.rcost
        total.rate += +item.rate
        total.r_rate += +item.r_rate
        total.price += +item.price
        total.cod_amount += +item.cod_amount
        total.remote_area += +item.remote_area
        total.r_remote_area += +item.r_remote_area
        total.travel_surcharge += +item.travel_surcharge
        total.r_travel_surcharge += +item.r_travel_surcharge
        total.island_surcharge += +item.island_surcharge
        total.r_island_surcharge += +item.r_island_surcharge
        total.fuel_surcharge += +item.fuel_surcharge
        total.r_fuel_surcharge += +item.r_fuel_surcharge
        total.insurance_cost += +item.insurance_cost
        total.insurance_rate += +item.insurance_rate
      })
      return total;
    }
  }
};
</script>

<style></style>
